import { useCurrentEditor } from "@tiptap/react";
import { useEffect, useRef, useState } from "react";
import { IconButton } from "../button";
import { Divider } from "../divider";
import { Check, ExternalLink1, XClose } from "../icons";
import { Input } from "../input";
import { BubbleMenu } from "./bubble-menu";

export const LinkBubbleMenu = () => {
  const [linkUrl, setLinkUrl] = useState("");
  const inputRef = useRef<HTMLInputElement>(null);
  const { editor } = useCurrentEditor();

  if (!editor) {
    return;
  }

  const updateLink = () => {
    if (linkUrl) {
      editor
        ?.chain()
        .focus()
        .extendMarkRange("link")
        .setLink({
          href: linkUrl.startsWith("https://") ? linkUrl : `https://${linkUrl}`,
        })
        .run();
      editor?.chain().setTextSelection(editor?.state.selection.to).run();
    } else {
      clearLink();
    }
  };

  const clearLink = () => {
    editor?.chain().focus().extendMarkRange("link").unsetLink().run();
    editor?.chain().setTextSelection(editor?.state.selection.to).run();
  };

  useEffect(() => {
    if (editor && editor.isActive("link")) {
      const url = editor.getAttributes("link").href ?? "";
      setLinkUrl(url);
      if (url === "") {
        setTimeout(() => {
          inputRef.current?.focus();
        }, 300);
      }
    }
  }, [editor?.state.selection]);

  return (
    <BubbleMenu
      pluginKey="link-menu"
      shouldShow={({ editor }) => {
        return (
          editor.isActive("link") &&
          (editor.state.selection.from !== editor.state.selection.to ||
            editor.state.selection.$to.nodeAfter?.marks.some(
              (mark) => mark.type.name === "link",
            ) === true)
        );
      }}
    >
      <div className="flex items-center gap-0.5 pr-0.5">
        <Input
          ref={inputRef}
          type="text"
          value={linkUrl}
          onChange={(e) => setLinkUrl(e.target.value)}
          placeholder="Enter link URL..."
          className="w-[224px] rounded-l-md text-sm border-none shadow-none focus:ring-0 ring-inset"
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              updateLink();
              e.preventDefault();
              e.stopPropagation();
            }
          }}
        />
        <Divider direction="vertical" className="h-6" />
        <IconButton
          onClick={updateLink}
          ariaLabel="Save"
          variant="tertiaryColor"
          size="xs"
          title="Save link"
        >
          <Check className="h-4 w-4 text-primary-600" />
        </IconButton>
        <Divider direction="vertical" className="h-6" />
        <IconButton
          onClick={clearLink}
          ariaLabel="Remove"
          variant="tertiaryColor"
          className="hover:bg-error-50 ring-error-200/70"
          size="xs"
          title="Remove link"
        >
          <XClose className="h-4 w-4 text-error-600" />
        </IconButton>
        <Divider direction="vertical" className="h-6" />
        <IconButton
          onClick={updateLink}
          ariaLabel="Open"
          variant="tertiaryGray"
          size="xs"
          asChild
          title="Open link in new tab"
        >
          <a href={linkUrl} target="_blank">
            <ExternalLink1 className="w-4 h-4" />
          </a>
        </IconButton>
      </div>
    </BubbleMenu>
  );
};
